<template>
  <section class="app-main" id="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive max="20">
        <router-view v-if="isKeepAlive" :key="key" />
      </keep-alive>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view v-if="!isKeepAlive" :key="key" />
    </transition>
    <!-- 子应用 slot 不能放入 过度标签内，会导致容器找不到-->
    <slot name="container"></slot>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import waterMark from '../mixin/waterMark'

export default {
  name: 'AppMain',
  mixins: [waterMark],
  computed: {
    ...mapGetters(['brandId', 'cacheRouteList', 'quneWaitRefreshRoute']),
    key() {
      return `${this.$route.name}${this.$route.path}`
    },
    // 是否缓存 还需要判断参数是否一致 当参数不一致时候 也需要重新刷新页面
    isKeepAlive() {
      // return false
      if (this.$route.meta.keepAlive !== undefined) { return this.$route.meta.keepAlive }
      /** 从vuex cacheRouteList 中获取 技改需求 20231031 https://bailongma.yuque.com/hhwu0d/nvrent/ivvalkzuuhe5yged */
      const index = this.cacheRouteList.findIndex((item) => {
        return item.name === this.$route.name
      })
      return index !== -1
    },
  },
  methods: {
    // 自动从keep-alive上删除 缓存内容
    autoRemoveCache(key, componentInstance) {
      const { keys, cache } = componentInstance
      if (!keys || !cache || !key) return
      const keyIndex = keys.indexOf(key)
      if (keyIndex > -1) {
        keys.splice(keyIndex, 1)
      }

      if (cache[key]) {
        const { parent } = cache[key].componentInstance.$vnode
        parent.componentOptions.children = []
        parent.elm = null
        delete cache[key]
      }
    },
    // 通过路由和当前页面缓存的child删除相关的内容
    handleRemoveCache(currentRoute) {
      const cacheRouteStr = `${currentRoute.name}${currentRoute.path}`
      // 如果 页面的key和目标key相符合 就可以进行接下来删除工作
      const child = this.$children.find((chd) => {
        return chd?.$vnode.data?.key === cacheRouteStr
      })
      if (!child || !child?.$vnode?.parent?.tag?.endsWith('keep-alive')) return
      this.autoRemoveCache(child.$vnode.key, child.$vnode.parent.componentInstance)
    },
  },
  watch: {
    quneWaitRefreshRoute(nVal) {
      // 如果route发生变化 清空 队列中需要缓存处理的路由
      if (nVal.length > 0) {
        nVal.forEach((keytem) => {
          this.handleRemoveCache(keytem)
        })
        this.$store.commit('DELETE_QUNE_WAIT_REFRESH_ROUTE')
      }
    },
  },
  mounted() {
    this.$EventBus.$on('autoRemoveCache', this.handleRemoveCache)
  },
}
</script>

<style scoped>
.app-main {
  position: relative;
  flex: 1;
  max-height: calc(100vh - 128px);
  overflow: auto;
  min-height: auto;
  padding: 16px;
  transition: all 0.2s;
  background: #fff;
}
/* .app-main::-webkit-scrollbar {
  display: none;
} */

.app-main.ishiddens {
  overflow-x: hidden;
}
.app-main-cont {
  position: relative;
  padding: 16px;
  min-height: 100%;
}
</style>
